/**
 * External dependencies
 */
import { useLocation, useNavigate } from 'react-router-dom';
import React from 'react';

/**
 * Internal dependencies
 */
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbSeparator,
  BreadcrumbList,
} from '../Breadcrumb/index';

type BreadcrumbItemType = {
  path: string;
  label: string;
};

type BreadcrumbWrapperProps = {
  crumbArray: BreadcrumbItemType[];
};

/**
 * Example of array usage:
 * const crumbArray = [
 *   { path: '/', label: 'Home' },
 *   { path: '/dashboard', label: 'Dashboard' },
 *   { path: '/dashboard/members', label: 'Members' },
 * ];
 */
const BreadcrumbWrapper = ({ crumbArray = [] }: BreadcrumbWrapperProps) => {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  return (
    <div className="flex items-center">
      <Breadcrumb>
        <BreadcrumbList>
          <BreadcrumbItem
            className={`cursor-pointer ${pathname !== '/dashboard' && 'opacity-50'}`}
            onClick={() => {
              navigate('/dashboard');
            }}
          >
            Dashboards
          </BreadcrumbItem>
          {crumbArray.map((crumb, i) => {
            return (
              <React.Fragment key={`breadcrumb-${i}`}>
                <BreadcrumbSeparator></BreadcrumbSeparator>
                <BreadcrumbItem
                  className={`cursor-pointer ${pathname !== crumb.path && 'opacity-50'}`}
                  onClick={() => {
                    navigate(crumb.path);
                  }}
                >
                  {crumb.label}
                </BreadcrumbItem>
              </React.Fragment>
            );
          })}
        </BreadcrumbList>
      </Breadcrumb>
    </div>
  );
};

export default BreadcrumbWrapper;
